import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import styled from 'styled-components'

import theme from '../../utils/theme'
import LabelWrapper from '../LabelWrapper'

const styles = theme => ({
  wrapper: {
    position: 'relative',
    '&.fullWidth': {
      width: '100%',
    },
    '&.topBorder': {
      marginTop: '16px',
      borderTop: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
      '& > div:first-child': {
        marginTop: '16px',
      },
    },
    '&.hide-labels .multipleFields.column > div > *:not(:first-child) .draggable-item .field-label': {
      display: 'none',
    },
  },
  heading: {
    fontSize: theme.typography.fontSizeMedish,
    fontWeight: theme.typography.fontWeightBolder,
    color: `var(--gameday-body-textColorDark, ${theme.body.textColorDark})`,
    margin: '12px 0 16px 0 !important',
  },
  topLabel: {
    margin: '0 0 6px',
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    width: '100%',
    '& > div': {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      width: '100%',
    },
  },
  gridWrap: {
    width: '100%',
    margin: 0,
    padding: 0,
  },
  grid: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridAutoRows: '200px',
    gap: '16px 16px',
    '& > div': {
      padding: 0,
      margin: 0,
      justifySelf: 'start',
      height: '100%',
      alignItems: 'flex-start',
    },
  },
})

const ListWrap = styled.div`
  margin: 0 0 16px;
  padding: 4px;
  border-radius: 4px;
  list-style-type: none;
  transition: background-color 200ms ease;
  background-color: ${props =>
    props.isDraggingOver && `var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`};
  > div {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
`

const StyledAddButton = styled.div`
  margin-top: ${props => props.hasChildren && '12px'};
  &.draggable {
    margin: 16px 0 0 20px;
  }
`

const ListItemsWrapper = ({
  bigLabel,
  buttonComponent,
  children,
  classes,
  className,
  customCol,
  customMargin,
  customPadding,
  customWidth,
  customWrapperWidth,
  draggable,
  errorText,
  firstLabelsOnly,
  fullWidth,
  heading,
  helperText,
  id,
  isGrid,
  isLabelInline,
  isRequired,
  isToolTip,
  label,
  multipleDirection,
  notWrapper,
  noWrap,
  onDragStart,
  onDragEnd,
  spacing,
  toolTipIcon,
  toolTipIconColor,
  toolTipIconSize,
  toolTipPosition,
  toolTipText,
  topBorder,
  topLabel,
  willDelete,
  withBorder,
  withDivider,
  ...rest
}) => (
  <LabelWrapper
    bigLabel={bigLabel}
    className={cn(
      {
        fullWidth,
        topBorder,
        'hide-labels': firstLabelsOnly,
      },
      className,
      classes.wrapper
    )}
    customCol={customCol}
    customMargin={customMargin}
    customPadding={customPadding}
    customWidth={customWidth}
    errorText={errorText}
    fullWidth={fullWidth}
    helperText={helperText}
    id={id}
    isRequired={isRequired}
    isToolTip={isToolTip}
    isLabelInline={isLabelInline}
    label={label}
    multipleFields
    multipleDirection={multipleDirection}
    notWrapper={notWrapper}
    noWrap={noWrap}
    spacing={spacing}
    toolTipIcon={toolTipIcon}
    toolTipIconColor={toolTipIconColor}
    toolTipIconSize={toolTipIconSize}
    toolTipPosition={toolTipPosition}
    toolTipText={toolTipText}
    willDelete={willDelete}
    withBorder={withBorder}
    withDivider={withDivider}
    {...rest}
  >
    {heading && <h3 className={classes.heading}>{heading}</h3>}
    {topLabel && <p className={classes.topLabel}>{topLabel}</p>}
    {draggable ? (
      <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
        <Droppable droppableId={`droppable${id}`}>
          {(provided, snapshot) => (
            <ListWrap
              ref={provided.innerRef}
              {...provided.droppableProps}
              isDraggingOver={snapshot.isDraggingOver}
              style={
                customWrapperWidth ? { width: `${customWrapperWidth}px` } : customWidth && { width: `${customWidth}px` }
              }
              className={cn({ [classes.gridWrap]: isGrid })}
            >
              <div
                className={cn(multipleDirection === 'row' && !isGrid && classes.row, { [classes.grid]: isGrid })}
                style={
                  customWrapperWidth
                    ? { width: `${customWrapperWidth}px` }
                    : customWidth && { width: `${customWidth}px` }
                }
              >
                {children}
                {provided.placeholder}
              </div>
            </ListWrap>
          )}
        </Droppable>
      </DragDropContext>
    ) : (
      <ListWrap>{children}</ListWrap>
    )}
    <StyledAddButton hasChildren={children[0].props.children[0] !== undefined}>{buttonComponent}</StyledAddButton>
  </LabelWrapper>
)

ListItemsWrapper.defaultProps = {
  isLabelInline: true,
  multipleDirection: 'column',
  notWrapper: false,
  withBorder: true,
  withDivider: false,
}

const ListItemsWrapperComponent = withStyles(styles)(ListItemsWrapper)
ListItemsWrapperComponent.displayName = 'ListItemsWrapper'
export default ListItemsWrapperComponent
